module.exports = __webpack_public_path__ + "static/media/ETC.ccc3433c.svg";